/**
 * Черновик «Нового ассистента» (экран 2): живёт в sessionStorage, чтобы переход на экран
 * выбора модели и обратно не терял введённое.
 */
export interface CreateDraft {
  name: string;
  description: string;
  /** Инструкция: составленная ИИ или поправленная клиентом. Пусто — составим при создании. */
  prompt: string;
  modelId: number | null;
  kb: 'files' | 'site' | 'skip' | null;
}

const KEY = 'richat.createDraft';
export const EMPTY_DRAFT: CreateDraft = { name: '', description: '', prompt: '', modelId: null, kb: null };

export function readDraft(): CreateDraft {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    return raw ? { ...EMPTY_DRAFT, ...(JSON.parse(raw) as Partial<CreateDraft>) } : { ...EMPTY_DRAFT };
  } catch {
    return { ...EMPTY_DRAFT };
  }
}

export function writeDraft(d: CreateDraft) {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(d));
  } catch {
    /* недоступно — черновик живёт только в памяти страницы */
  }
}

export function clearDraft() {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
